var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.54 9.00015L8.87997 3.46015C7.8159 2.8457 6.50398 2.8493 5.4433 3.46959C4.38261 4.08987 3.7362 5.23149 3.74997 6.46015V17.5801C3.74997 19.469 5.28116 21.0001 7.16997 21.0001C7.77041 20.9991 8.36006 20.8405 8.87997 20.5401L18.54 15.0001C19.5964 14.3888 20.2468 13.2607 20.2468 12.0401C20.2468 10.8196 19.5964 9.69154 18.54 9.08015V9.00015ZM17.54 13.1903L7.87997 18.8103C7.43955 19.0599 6.9004 19.0599 6.45997 18.8103C6.02055 18.5566 5.74989 18.0877 5.74997 17.5803V6.42026C5.74989 5.91286 6.02055 5.44396 6.45997 5.19026C6.67738 5.06942 6.92127 5.00415 7.16997 5.00026C7.41851 5.00536 7.66211 5.07055 7.87997 5.19026L17.54 10.7703C17.9796 11.0239 18.2504 11.4928 18.2504 12.0003C18.2504 12.5078 17.9796 12.9767 17.54 13.2303V13.1903Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.1c832fff.svg";
export { ForwardRef as ReactComponent };